export default {
    googlefitvalues: {
    startTimeMillis:"1653955201000",
    endTimeMillis:"1653990971166"
    }
  }